import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { RepairCodeExclusionSearchTextForm } from '../../../form-model/repair-code-exclusion-search-text.form.model';
import { addMissingControls, isTouchedAndInvalid } from '../../../helper/reactive-form-helpers';

@Component({
  selector: 'app-repair-code-exclusion-search',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './repair-code-exclusion-search.component.html',
  styleUrl: './repair-code-exclusion-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairCodeExclusionSearchComponent implements OnInit {
  @Input({ required: true }) searchTextForm!: FormGroup<RepairCodeExclusionSearchTextForm>;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.addControlsToTheFormGroup();
  }

  applySearchTextFilters(): void {
    this.searchTextForm.controls.appliedSearchTextFilter.setValue(true);
  }

  isControlInErrorState(control: FormControl): boolean | null {
    return isTouchedAndInvalid(control);
  }

  private addControlsToTheFormGroup(): void {
    addMissingControls(this.searchTextForm, [
      { name: 'SearchText', control: this.formBuilder.control<string | null>(null) },
      { name: 'appliedSearchTextFilter', control: this.formBuilder.control<boolean | null>(null) },
    ]);
  }
}
